import React from 'react';
import { useNavigate } from 'react-router-dom';
import ExecutiveOfficerManagement from '../components/ExecutiveOfficerManagement';

const ExecutiveOfficersPage = () => {
    const navigate = useNavigate();

    // Wrapper to handle close by navigating back or doing nothing if it is a page
    const handleClose = () => {
        navigate('/dashboard');
    };

    return (
        <div className="container-fluid py-4">
            <div className="row mb-4">
                <div className="col-12">
                    <h1 className="h3 mb-1">
                        <i className="bi bi-person-badge me-2"></i>
                        Executive Officers
                    </h1>
                    <p className="text-muted mb-0">Manage your executive officers list</p>
                </div>
            </div>

            <div className="row justify-content-center">
                <div className="col-md-8 col-lg-6">
                    {/* We reuse the component but might need to adjust styling if it expects to be a modal */}
                    <div className="card shadow-sm">
                        <div className="card-body p-0">
                            <ExecutiveOfficerManagement onClose={handleClose} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExecutiveOfficersPage;
